import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils/cn'

export type RecordStatus =
  | 'draft'
  | 'in_progress'
  | 'submitted'
  | 'under_review'
  | 'approved'
  | 'needs_revision'
  | 'deleted'
  | 'active'
  | 'paused'
  | 'closed'
  | 'archived'

const STATUS_CONFIG: Record<
  RecordStatus,
  { label: string; className: string }
> = {
  draft: {
    label: 'پیش‌نویس',
    className: 'bg-muted text-muted-foreground border-border',
  },
  in_progress: {
    label: 'در جریان',
    className: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  },
  submitted: {
    label: 'ارسال شده',
    className: 'bg-purple-500/15 text-purple-400 border-purple-500/30',
  },
  under_review: {
    label: 'در حال بررسی',
    className: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
  },
  approved: {
    label: 'تأیید شده',
    className: 'bg-secondary/20 text-secondary border-secondary/30',
  },
  needs_revision: {
    label: 'نیاز به اصلاح',
    className: 'bg-destructive/15 text-red-400 border-destructive/30',
  },
  deleted: {
    label: 'حذف شده',
    className: 'bg-muted text-muted-foreground/60 border-border line-through',
  },
  active: {
    label: 'فعال',
    className: 'bg-secondary/20 text-secondary border-secondary/30',
  },
  paused: {
    label: 'متوقف',
    className: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
  },
  closed: {
    label: 'بسته شده',
    className: 'bg-muted text-muted-foreground border-border',
  },
  archived: {
    label: 'بایگانی',
    className: 'bg-muted text-muted-foreground/60 border-border',
  },
}

interface StatusBadgeProps {
  status: RecordStatus
  className?: string
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status]
  return (
    <Badge
      variant="outline"
      className={cn('text-xs font-medium', config.className, className)}
    >
      {config.label}
    </Badge>
  )
}
